import { type TableFeature, type RowData, type Table, type Row } from "@tanstack/react-table";

export interface HoveredRowTableState {
  hoveredRowId: string | undefined;
}

export interface HoveredRowInstance {
  isHovered?: () => boolean;
  setHovered?: () => void;
  setNotHovered?: () => void;
}

export const HoveredRowFeature: TableFeature = {
  getInitialState: (state): HoveredRowTableState => {
    return {
      hoveredRowId: undefined,
      ...state,
    };
  },

  createRow: <TData extends RowData>(row: Row<TData>, table: Table<TData>) => {
    row.isHovered = () => table.getState().hoveredRowId === row.id;
    row.setHovered = () =>
      table.setState(old => (old.hoveredRowId === row.id ? old : { ...old, hoveredRowId: row.id }));
    row.setNotHovered = () =>
      table.setState(old => (old.hoveredRowId === row.id ? { ...old, hoveredRowId: undefined } : old));
  },
};
